export const productFamilies =  [
  { text: "one", value: "ONE" },
  { text: "nano", value: "NANO" },
  { text: "carbon", value: "CARBON" },
  { text: "move", value: "MOVE" },
  { text: "base", value: "BASE" },
  { text: "powertrack", value: "POWERTRACK" },
]